import React from "react";
const Footer = () => {
    return (

        <footer class="w-full bg-[#003a76] self-center py-3 text-center text-white font-medium">
            © 2024 Copyright : Suraj Savji
        </footer>

    )
}
export default Footer;